const skills = [
  {
    title_skill: 'Web Developer',
    capacity_1: 'Strong knowledge of HTML, CSS, and JavaScript.',
    capacity_2: 'Skilled in building and customizing websites on WordPress, offering clients a flexible and powerful content management solution.',
    capacity_3: 'Experience with frameworks and libraries like React and Next.js.',
    capacity_4: 'Familiarity with tools like Git and Docker for version control and deployment.',
    cta: 'Show my work',
    link: '/projects/',
  },

  {
    title_skill: 'Web Design',
    capacity_1: 'Proficiency in creating responsive and user-friendly web interfaces.',
    capacity_2: 'Understanding of UX/UI principles to enhance user experience.',
    capacity_3: 'Experience with design tools such as Figma, Adobe XD, Adobe Illustrator and Pixso.',
    capacity_4: 'I can assist in developing logos and creating comprehensive brand books to establish a strong visual identity for your business.',
    cta: 'Show my work',
    link: '/projects/',
  },

  {
    title_skill: 'Photography',
    capacity_1: 'Photography skills, including composition, lighting, and editing.',
    capacity_2: 'Expertise in photo editing software like Adobe Photoshop and Lightroom.',
    capacity_3: 'Ability to integrate original photography into web projects for a unique visual appeal.',
    capacity_4: 'photographer with a keen eye for detail, specializing in portrait photography, as well as capturing small corporate events and special occasions.',
    cta: 'Show my work',
    link: '/gallery',
  },
];

export {skills}